import React from 'react';
import { PdfFieldEntity } from '../data/PdfDataKey';
import { PdfFieldResolving } from '../data/PdfFieldResolving';
import { PdfBarcodeComponent } from '../PdfComponent';
import { usePdfTemplateContext } from '../PdfTemplateEditorContext';

interface PdfTemplateBarcodePreviewProps {
  component: PdfBarcodeComponent;
}

export default function PdfTemplateBarcodePreview<T>({ component }: PdfTemplateBarcodePreviewProps) {
  const { dataKeys: fieldProviders, fontToCss, selectedEntity, documentProperties, data } = usePdfTemplateContext<T>();

  const justifyContent = (() => {
    return 'center';
  })();

  const alignItems = (() => {
    return 'center';
  })();

  let text = !component.key
    ? ''
    : selectedEntity
    ? PdfFieldResolving.getValue(selectedEntity, PdfFieldEntity.order, component.key, data)
    : PdfFieldResolving.getLabel(component.key, data);

  return (
    <div
      className={`flex h-full w-full`}
      style={{
        ...fontToCss(documentProperties.font),
        justifyContent: justifyContent,
        alignItems: alignItems,
      }}
    >
      <span>{text}</span>
    </div>
  );
}
